module.exports = __webpack_public_path__ + "img/director-school-icon8.11e2a919.jpg";